module.exports = __webpack_public_path__ + "img/logo.4935db5e.png";